/*
 * General custom scripts
 */
import scrollManager from './front/ScrollManager';
import resizeManager from './front/ResizeManager';

// Expose the page-wide scroll/resize managers so per-block bundles (built as
// separate webpack entries, no shared chunk) can subscribe via window.wombat
// instead of each adding their own listener. See ScrollManager's docblock.
//
// Deliberately NOT importing './bootstrap' here: it pulls in
// @fooz/wombat-react-components, which expects block-editor-only WP globals
// (e.g. wp.element) that don't exist on the front-end and throw on load.
window.wombat = {
	...window.wombat,
	scrollManager,
	resizeManager,
};

import './front/social-share';
import initSkipToMain from './front/skip-to-main';
import initAnalytics from './front/analytics';

initSkipToMain();
initAnalytics();

